import {TripCollection} from "../Trip";
import valeaPh from "../../../assets/child/valeaPh.jpg";

const dayChildValeaPh: TripCollection = {
    imageSrc: valeaPh,
    trips: [
        {
            name: "9.1. Sinaia – poveşti din Oraşul Regal",
            route: "Braşov – Sinaia – Braşov",
            days: [
                [
                    {
                        locationName: "Castelul Peleş",
                        details: "Necesită rezervare cu minim 20 de zile înainte"
                    },
                    {
                        locationName: "Castelul Pelişor",
                        details: "Necesită rezervare cu minim 20 de zile înainte"
                    },
                    {
                        locationName: "Mănăstirea Sinaia",
                    },
                    {
                        locationName: "Casa Memorială George Enescu",
                    },
                ]
            ],
            notes: "O excursie deosebită care te poartă prin istoria și cultura României. Prima oprire este la Castelul Peleș, bijuterie a arhitecturii neorenascentiste, unde vizitatorii descoperă eleganța și rafinamentul epocii regale. Urmează Castelul Pelișor, cu atmosfera sa intimă și colecțiile fascinante, ce completează experiența regală. Traseul continuă la Mănăstirea Sinaia, un important lăcaș de cult și centru spiritual al zonei, și se încheie la Casa Memorială George Enescu, unde vizitatorii descoperă viața și creația unuia dintre cei mai mari muzicieni români. Excursia oferă o combinație perfectă între istorie, cultură și frumos, lăsând amintiri de neuitat."
        },
        {
            name: "9.2. Castelele de pe Valea Prahovei",
            route: "Braşov – Sinaia – Buşteni – Braşov",
            days: [
                [
                    {
                        locationName: "Castelul Peleş",
                        details: "Necesită rezervare cu minim 20 de zile înainte"
                    },
                    {
                        locationName: "Castelul Pelişor",
                        details: "Necesită rezervare cu minim 20 de zile înainte"
                    },
                    {
                        locationName: "Mănăstirea Sinaia",
                    },
                    {
                        locationName: "Casa Memorială George Enescu",
                    },
                    {
                        locationName: "Castelul Cantacuzino (Nevermore Academy)",
                    },
                ]
            ],
            notes: "Pornește într-o aventură plină de istorie, cultură și mister. Vei explora Castelul Peleș, bijuteria regală a României, și Castelul Pelișor, cu atmosfera sa intimă și detaliile spectaculoase. Traseul continuă la Mănăstirea Sinaia, un loc de liniște și spiritualitate, și la Casa Memorială George Enescu, unde viața și creația marelui compozitor prind viață. Aventura se încheie la Castelul Cantacuzino din Bușteni, unde istoria se întâlnește cu misterul, oferind experiențe memorabile și momente de neuitat pentru fiecare vizitator."
        },
        {
            name: "9.3. Poveşti Vânătoreşti",
            route: "Braşov – Posada – Sinaia – Braşov",
            days: [
                [
                    {
                        locationName: "Muzeul Cinegetic Posada",
                    },
                    {
                        locationName: "Castelul Peleş",
                        details: "Necesită rezervare cu minim 20 de zile înainte"
                    },
                    {
                        locationName: "Mănăstirea Sinaia",
                    },
                    {
                        locationName: "Casa Memorială George Enescu",
                    },
                ]
            ],
            notes: "Programul propune o incursiune culturală și istorică inspirată din tradițiile vânătorești și atmosfera aristocratică a începutului de secol. Vizita la Muzeul Cinegetic Posada oferă ocazia de a descoperi fauna specifică zonei și povești autentice legate de vânătoarea tradițională. Experiența continuă la Castelul Peleș, simbol al eleganței regale, unde arhitectura spectaculoasă și colecțiile valoroase impresionează orice vizitator. Traseul include Mănăstirea Sinaia, important lăcaș de cult și spațiu de reculegere, iar excursia se încheie la Casa Memorială George Enescu, unde viața și creația marelui compozitor român sunt puse în valoare într-un cadru intim și plin de inspirație."
        },
        {
            name: "9.4. Câmpina",
            route: "Braşov – Sinaia – Câmpina – Braşov",
            days: [
                [
                    {
                        locationName: "Castelul Peleş",
                        details: "Necesită rezervare cu minim 20 de zile înainte"
                    },
                    {
                        locationName: "Mănăstirea Sinaia",
                    },
                    {
                        locationName: "Casa Memorială Nicolae Grigorescu",
                    },
                    {
                        locationName: "Muzeul Memorial Bogdan Petriceicu Haşdeu",
                    },
                ]
            ],
            notes: "Programul propune o incursiune culturală ce îmbină eleganța regală cu patrimoniul artistic și literar al României. Vizita la Castelul Peleș oferă ocazia de a admira una dintre cele mai spectaculoase reședințe regale, renumită pentru arhitectura sa și colecțiile impresionante. Traseul continuă la Mănăstirea Sinaia, important lăcaș de cult și reper spiritual al zonei. Experiența culturală este completată la Câmpina, unde Casa Memorială Nicolae Grigorescu dezvăluie viața și creația unuia dintre cei mai mari pictori români, iar Muzeul Memorial Bogdan Petriceicu Hașdeu impresionează prin povestea sa aparte și valoarea culturală deosebită. Excursia oferă o zi dedicată artei, istoriei și culturii românești."
        },
        {
            name: "9.5. Ploiești I",
            route: "Braşov – Sinaia – Ploieşti – Braşov",
            days: [
                [
                    {
                        locationName: "Castelul Peleş",
                        details: "Necesită rezervare cu minim 20 de zile înainte"
                    },
                    {
                        locationName: "Mănăstirea Sinaia",
                    },
                    {
                        locationName: "Muzeul Ceasului “Nicolae Simache”",
                    },
                    {
                        locationName: "Muzeul de Ştiinţe ale Naturii",
                    },
                ]
            ],
            notes: "Programul oferă o incursiune culturală diversă, îmbinând rafinamentul arhitecturii regale cu descoperiri captivante din domeniul științei și al istoriei. Vizita la Castelul Peleș impresionează prin eleganța sa și colecțiile de excepție, fiind urmată de Mănăstirea Sinaia, un important reper spiritual și istoric al zonei. Traseul continuă la Ploiești, cu Muzeul Ceasului „Nicolae Simache”, unic în România, unde sunt prezentate piese valoroase ce ilustrează evoluția măsurării timpului. Excursia se încheie la Muzeul de Științe ale Naturii, un spațiu educativ și atractiv, ce pune în valoare diversitatea lumii naturale și contribuie la o experiență completă de învățare și explorare."
        },
        {
            name: "9.6. Ploiești II",
            route: "Braşov – Câmpina – Ploieşti – Braşov",
            days: [
                [
                    {
                        locationName: "Casa Memorială Nicolae Grigorescu",
                    },
                    {
                        locationName: "Muzeul Memorial Bogdan Petriceicu Haşdeu",
                    },
                    {
                        locationName: "Muzeul Ceasului “Nicolae Simache”",
                    },
                ]
            ],
            notes: "Programul propune o incursiune culturală dedicată artei, literaturii și patrimoniului național. Traseul începe la Câmpina, cu vizitarea Casei Memoriale Nicolae Grigorescu, loc în care vizitatorii descoperă universul artistic și parcursul unuia dintre cei mai importanți pictori români. Experiența continuă la Muzeul Memorial Bogdan Petriceicu Hașdeu, un spațiu încărcat de istorie și simbolism, ce reflectă personalitatea complexă a marelui savant și scriitor. Programul este completat la Ploiești de Muzeul Ceasului „Nicolae Simache”, instituție unică în România, ce impresionează prin colecții valoroase și prin povestea fascinantă a măsurării timpului. Excursia oferă o experiență culturală coerentă și rafinată, ideală pentru aprofundarea patrimoniului românesc."
        },
        {
            name: "9.7. Ploiești III",
            route: "Braşov – Ploieşti – Posada – Braşov",
            days: [
                [
                    {
                        locationName: "Muzeul Ceasului “Nicolae Simache”",
                    },
                    {
                        locationName: "Muzeul de Ştiinţe ale Naturii",
                    },
                    {
                        locationName: "Muzeul Cinegetic Posada",
                    },
                ]
            ],
            notes: "Programul oferă o experiență cultural-educativă echilibrată, reunind știința, patrimoniul muzeal și tradițiile cinegetice. Vizita la Ploiești începe cu Muzeul Ceasului „Nicolae Simache”, instituție unică în România, unde sunt expuse piese valoroase ce ilustrează evoluția măsurării timpului. Traseul continuă cu Muzeul de Științe ale Naturii, un spațiu modern și educativ, dedicat cunoașterii diversității lumii naturale. Excursia se încheie la Muzeul Cinegetic Posada din Comarnic, unde vizitatorii descoperă fauna specifică zonei și tradițiile vânătorii, într-un cadru informativ și captivant. Programul propune o zi de explorare și învățare, potrivită pentru toate categoriile de vizitatori."
        },
        {
            name: "9.8. Ploiești IV",
            route: "Braşov – Siliştea Snagovului – Ploieşti – Braşov",
            days: [
                [
                    {
                        locationName: "Mănăstirea Snagov",
                    },
                    {
                        locationName: "Muzeul Ceasului “Nicolae Simache”",
                    },
                    {
                        locationName: "Muzeul de Ştiinţe ale Naturii",
                    },
                    {
                        locationName: "Casa Memorială I.L. Caragiale",
                    },
                ]
            ],
            notes: "Programul propune o incursiune culturală complexă, care îmbină patrimoniul spiritual, istoria literară și descoperirea științifică. Vizita începe la Mănăstirea Snagov, un important lăcaș de cult, încărcat de istorie și tradiție, amplasat într-un cadru natural deosebit. Traseul continuă la Ploiești cu Muzeul Ceasului „Nicolae Simache”, instituție unică în România, ce adăpostește colecții valoroase dedicate măsurării timpului, urmat de Muzeul de Științe ale Naturii, un spațiu educativ ce pune în valoare diversitatea lumii naturale. Excursia se încheie la Casa Memorială I.L. Caragiale, loc emblematic al culturii românești, unde viața și opera marelui dramaturg sunt readuse în prim-plan. Programul oferă o experiență culturală echilibrată și memorabilă."
        },
    ]
}

export default dayChildValeaPh;